export default [
  {
    path: '/sales/invoices',
    name: 'sales-invoices',
    component: () => import('@/views/commissions/SalesInvoices.vue'),
    meta: {
      requireLogin: true,
      roles: ['sales'],
      pageTitle: 'Mes Factures de Commission',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: { name: 'dashboard' },
        },
        {
          text: 'Mes Factures',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sales/invoices/:id',
    name: 'sales-invoice-detail',
    component: () => import('@/views/commissions/SalesInvoiceDetail.vue'),
    meta: {
      requireLogin: true,
      roles: ['sales'],
      pageTitle: 'Détail de Facture',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: { name: 'dashboard' },
        },
        {
          text: 'Mes Factures',
          to: { name: 'sales-invoices' },
        },
        {
          text: 'Détail',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sales/suppliers',
    name: 'sales-suppliers',
    component: () => import('@/views/commissions/SalesSuppliers.vue'),
    meta: {
      requireLogin: true,
      roles: ['sales'],
      pageTitle: 'Mes Fournisseurs Attribués',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: { name: 'dashboard' },
        },
        {
          text: 'Mes Fournisseurs',
          active: true,
        },
      ],
    },
  },
  // Admin routes for commission management
  {
    path: '/admin/commission-rates',
    name: 'admin-commission-rates',
    component: () => import('@/views/commissions/AdminCommissionRates.vue'),
    meta: {
      requireLogin: true,
      requiresAdmin: true,
      pageTitle: 'Taux de Commission',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: { name: 'dashboard' },
        },
        {
          text: 'Taux de Commission',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/supplier-attributions',
    name: 'admin-supplier-attributions',
    component: () => import('@/views/commissions/AdminSupplierAttributions.vue'),
    meta: {
      requireLogin: true,
      requiresAdmin: true,
      pageTitle: 'Attributions Fournisseurs',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: { name: 'dashboard' },
        },
        {
          text: 'Attributions Fournisseurs',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/commission-invoices',
    name: 'admin-commission-invoices',
    component: () => import('@/views/commissions/AdminCommissionInvoices.vue'),
    meta: {
      requireLogin: true,
      requiresAdmin: true,
      pageTitle: 'Factures de Commission',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: { name: 'dashboard' },
        },
        {
          text: 'Factures de Commission',
          active: true,
        },
      ],
    },
  },
]
